import {
  StyledCiFacebook,
  StyledAiOutlineInstagram,
  StyledFiTwitter,
  StyledFaLinkedinIn,
} from './styles/index';

const TeamData = [
  {
    id: 1,
    image: './images/personTeam1.jpg',
    name: 'Василь',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
  {
    id: 2,
    image: './images/personTeam2.jpg',
    name: 'Назар',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
  {
    id: 3,
    image: './images/personTeam3.jpg',
    name: 'Ліна',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
  {
    id: 4,
    image: './images/personTeam4.jpg',
    name: 'Олеся',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
  {
    id: 5,
    image: './images/personTeam5.jpg',
    name: 'Михайло',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
  {
    id: 6,
    image: './images/personTeam6.jpg',
    name: 'Степан',
    profession: 'Кухар',
    socials: [
      <StyledCiFacebook key={1} />,
      <StyledAiOutlineInstagram key={2} />,
      <StyledFiTwitter key={3} />,
      <StyledFaLinkedinIn key={4} />,
    ],
  },
];

export default TeamData;
